import { useState, useEffect } from 'react';
import './FreshWaterIrrigation.css';
import FreshWaterIrrigation from './FreshWaterIrrigation';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const FreshWaterIrrigationRisk = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {

    const [freshWaterIrrigation, setFreshWaterIrrigation] = useState({
        Section: 'IrrigationRisk', SectionName: 'Irrigation', IsMapOnly: false, IsMapRisk: false
    });

    useEffect(() => {
        OnPageload();
    }, [])
    const OnPageload = async (e) => {

    }

    return (
        <div>
            <FreshWaterIrrigation handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} handleMoveToNextPage={handleMoveToNextPage} pageSection={freshWaterIrrigation} ></FreshWaterIrrigation>
        </div>
    )
}
export default FreshWaterIrrigationRisk;